<template>
  <v-form ref="form">
    <v-container>
      <v-row>
        <v-col cols="12" md="6" sm="6">
          <div>
            <v-select
              solo
              :items="classes"
                :error-messages="errors.class_id"
              item-text="class_name"
              item-value="class_id"
              label="Select Class"
              v-model="data.class_id"
              @change="getStudent()"
            ></v-select>
          </div>
        </v-col>
<!-- {{data.subject+"GH"}} -->
        <v-col cols="12" md="6" sm="6">
          <div>
            
            <v-select
              solo
              @change="find()"
                :error-messages="errors.subject"
              :items="subjects"
              item-text="subject_name"
              item-value="subject_code"
              label="Select Subject"
              v-model="data.subject"
            ></v-select>
          </div>
        </v-col>

        <v-col cols="12" md="6" sm="6">
          <div>
            <v-select
              solo
              @change="find()"
              :items="months"
                :error-messages="errors.month"
              item-text="name"
              item-value="name"
              label="Select Month"
              v-model="data.month"
            ></v-select>
          </div>
        </v-col>
        <v-col cols="12" md="6" sm="6">
          <div>
            <v-select
              solo
                @change="find()"
              :items="weeks"
                :error-messages="errors.week"
              item-text="name"
              item-value="name"
              label="Select Week"
              v-model="data.week"
            ></v-select>
          </div>
        </v-col>

        <v-col cols="12" md="6" sm="6">
          <div>
            <label>Select Version </label>
            <v-select
              solo
              @change="find()"
                :error-messages="errors.version"
              :items="version"
              item-text="version"
              item-value="version"
              placeholder="Please Enter Version"
              label="Version"
              required
              v-model="data.version"
            ></v-select>
          </div>
        </v-col>
        <hr />
        <v-col cols="12" md="6" sm="6" v-if="this.sheets.length > 0">
          <div>
            <v-select
              solo
              :items="sheets"
                :error-messages="errors.work_sheet"
              item-text="name"
              item-value="work_sheet_id"
              label="Select Work Sheet"
              v-model="data.work_sheet"
            ></v-select>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="6" v-if="this.sheets.length > 0">
          <v-select
            required
            v-model="data.std_id"
              :error-messages="errors.std_id"
            :items="students"
            label="Choose Students"
            placeholder="Choose Students"
            solo
            multiple
          :item-text="getFieldText"
            item-value="std_id"
            append-outer-icon="mdi mdi-plus"
            @click:append-outer="addSubject = true"
          >
         
          </v-select>
        </v-col>
      </v-row>
      <v-row>
          <v-col cols="12" sm="6" md="6" v-if="this.sheets.length > 0">
         <div>
            <v-select
              solo
              required
              :items="items"
                :error-messages="errors.tutor_id"
               :item-text="getTutorFieldText"
            
              item-value="tutor_id"
              label="Select Tutor"
              v-model="data.tutor_id"
            ></v-select>
          </div>
        </v-col>
      </v-row>
      <v-row v-if="this.sheets.length > 0">
        <v-col cols="12">
          <v-btn color="#6A158E" @click="print()" large dark>Assign</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import Form from "../../utils/form/Form";
import { bus } from '../../main';
export default {
  name: "PrintWorkSheet",
  data() {
    return {
       errors:{},
      sheets: [],
      students: [],
      subjects: [],
      items: [],
      version: [
        { version: "1" },
        { version: "2" },
        { version: "3" },
        { version: "4" },
        { version: "5" },
        { version: "6" },
        { version: "7" },
        { version: "8" },
        { version: "9" },
        { version: "10" },
      ],
      months: [
        { name: "1 (September)" },
        { name: "2 (October)" },
        { name: "3 (November)" },
        { name: "4 (December)" },
        { name: "5 (January)" },
        { name: "6 (February)" },
        { name: "7 (March)" },
        { name: "8 (April)" },
        { name: "9 (May)" },
        { name: "10 (June)" },
        { name: "11 (July)" },
        { name: "12 (August)" },
      ],
      weeks: [{ name: " 1" }, { name: " 2" }, { name: " 3" }, { name: " 4" }],

      classes: [],
      data: {
        std_id: [],
        week: "",
        month: "",
        class_id: "",
        subject: null,
        version: "",
        work_sheet: "",
      },
    };
  },
  methods: {
    compare(prop) {
    return function (a,b) {
    console.log(prop) // outputs -> name
    return -1; // sort stuff
  }
},
      getTutorFieldText (item)
  {
    return `${item.tutor_fname} - ${item.tutor_lname}`
  },
    getFieldText (item)
  {
    return `${item.std_fname} - ${item.std_lname}`
  },
    file(e) {
      this.data.work_sheet = event.target.files[0];
    },
    print() {
      axios
        .post(apiRoutes.WorkSheet.assign, this.data)
        .then((response) => {
          bus.$emit('workSheetPrint');
          this.$refs.form.reset();
          this.errors = {};
            Toast.fire({
              icon: "success",
              title: "Worksheet Assigned Successfully",
              
            });
        })
        .catch((error) => {
          // console.log(error.response)
          if (error.response.status === 400) {
            this.errors = error.response.data;
          }
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
          this.loading = false;
        });
    },
    find() {
      axios
        .post(apiRoutes.WorkSheet.getWorkSheet, this.data)
        .then((response) => {
          this.sheets = response.data.response;
        })
        .catch((response) => {
          if (response.status === 422) {
            this.errors = response.data.errors;
          }
        });
    },
    getItems() {
      axios.get(apiRoutes.classes.url).then((response) => {
        this.classes = response.data.response;
        this.loading = false;
      });
    },

    getStudent() {
      axios
        .post("/get-student", { id: this.data.class_id })
        .then((response) => {
          this.students = response.data.response.sort(function(a, b) {
              var textA = a.std_fname?.toUpperCase();
              var textB = b.std_fname?.toUpperCase();
              return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          });
          this.loading = false;
          this.find();
        });
    },
      getSubject() {
      axios.get(apiRoutes.subjects.url).then((response) => {
        // console.log(response);
        this.subjects = response.data.response;
        // console.log(this.subjects);
        this.loading = false;
      });
    },
      getTutor() {
      axios.get(apiRoutes.tutors.url).then((response) => {
        this.items = response.data.response.sort(function(a, b) {
              var textA = a.tutor_fname?.toUpperCase();
              var textB = b.tutor_fname?.toUpperCase();
              return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
          });;
        this.loading = false;
      });
    },
  },
  mounted() {
    this.getItems();
    this.getSubject();
    this.getTutor();
  },
};
</script>
